import React from "react"
import { Link } from "gatsby"
import { H4 } from "../el/appnotetypography"
import { twMerge } from "tailwind-merge"
const ProductBlockNew = props => {
  const usedIn =
    props.type === "appnote"
      ? "in Application"
      : props.type === "video"
        ? "in Video"
        : ""

  // ProductLink Component
  const ProductLink = props => {
    return (
      <Link
        className={twMerge([
          "group",
          "flex items-center rounded-md border border-blue-200 bg-white px-1 py-0.5 transition hover:border-blue-400 hover:bg-slate-50",
        ])}
        to={props.slug}
      >
        <div className="mr-2 h-12 w-12 shrink-0 overflow-hidden rounded-md">
          <img
            alt={props.alt}
            src={`/product-thumbnails/${props.image}`}
            className="rounded-md w-12 h-12 object-cover"
          />
        </div>
        <div className="w-3/4 overflow-hidden">
          <h3 className="truncate text-xs font-semibold text-slate-800">
            {props.title}
          </h3>
          <p className="truncate text-xs font-light text-slate-600">
            {props.description}
          </p>
          <p className="text-xs font-light italic text-slate-400">
            <span className="mr-1.5">pn#</span>
            {props.pn}
          </p>
        </div>
      </Link>
    )
  }

  return (
    <div className="mt-8 rounded-sm bg-white shadow-md lg:mb-8 lg:mt-0">
      <div className="h-full rounded-sm pb-6 pt-6 shadow-sm">
        <div className="h-full px-4">
          <div className="h-full py-2">
            {props.productData.edges && props.productData.edges.length > 0 && (
              <>
                <H4 key="product">
                  Product{props.productData.edges.length > 1 && `s`} Used{" "}
                  {usedIn}
                </H4>
                <div className="mb-4 space-y-1.5">
                  {props.productData.edges &&
                    props.productData.edges.map(item => {
                      return (
                        <ProductLink
                          alt={item.node.title}
                          key={item.node.partNumber[0].num}
                          slug={item.node.slug}
                          title={item.node.title}
                          image={item.node.image}
                          description={item.node.desc_main}
                          pn={item.node.partNumber[0].num}
                        />
                      )
                    })}
                </div>
              </>
            )}

            {props.productRelatedData.edges &&
              props.productRelatedData.edges.length > 0 && (
                <>
                  <H4 key="related">Related Products</H4>
                  <div className="space-y-1.5">
                    {props.productRelatedData.edges.map(item => {
                      return (
                        <ProductLink
                          alt={item.node.title}
                          key={item.node.partNumber[0].num}
                          slug={item.node.slug}
                          title={item.node.title}
                          image={item.node.image}
                          description={item.node.desc_main}
                          pn={item.node.partNumber[0].num}
                        />
                      )
                    })}
                  </div>
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductBlockNew
